export function mapColsWidth(
  width: '4 cols' | '6 cols' | '8 cols' | '10 cols' | '12 cols' | undefined
) {
  if (width) {
    return parseInt(width.replace(' cols', ''), 10);
  }
}
